import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMounted } from '@vueuse/core';

import PictureComp from '@/components/picture/PictureComp.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import InfiniteScroll from '@/components/list/InfiniteScroll.vue';

import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import { ArticleClickedData, BlockArticle } from '@/features/editorial/types/editorial-types';

import { useArticleTimeline } from '@/features/editorial/composables/useArticleTimeline';
import { TIMELINE_PAGE_ANCHOR } from '@/features/editorial/composables/useTimelinePageScroll';
import { formatDateTime, isToday, isYesterday } from '@/helpers/date-helper';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleTimeline',
  emits: ["articleClicked", "authorClicked", "load-next"],
  setup(__props, { emit: emits }: { emit: ({
	(e: 'articleClicked', data: ArticleClickedData): void;
	(e: 'authorClicked', id: string | undefined): void;
	(e: 'load-next', data: any): void;
}), expose: any, slots: any, attrs: any }) {



const timeline = ref<HTMLElement | null>(null);

const { articleTimeline, loading, hasMore, fetchMoreArticles, pageBoundaryBuckets } = useArticleTimeline(timeline);
const { tc } = useI18n();
const isMounted = useMounted();

const totalArticleCount = computed(
	() => articleTimeline.value?.reduce((sum, group) => sum + group.articles.length, 0) ?? 0
);

const { language, country } = storeToRefs(useLanguageStore());

function formatBucketDate(date: Date | string) {
	const bucketDate = new Date(date);

	if (isMounted.value) {
		if (isToday(bucketDate)) return tc('WEBAPP_TODAY');
		if (isYesterday(bucketDate)) return tc('WEBAPP_YESTERDAY');
	}

	return formatDateTime(bucketDate, language.value, country.value, {});
}

function handleArticleClick(article: BlockArticle, index: number) {
	const articleData = {
		slug: article.content.fullPath,
		articleType: article.content.articleType,
		index,
	};

	emits('articleClicked', articleData);
}

async function handleLoadNext({ event }: { event: { target: { complete: (listLen?: number) => void } } }) {
	await fetchMoreArticles();
	event.target.complete(totalArticleCount.value);
}

return { __sfc: true,emits, timeline, articleTimeline, loading, hasMore, fetchMoreArticles, pageBoundaryBuckets, tc, isMounted, totalArticleCount, language, country, formatBucketDate, handleArticleClick, handleLoadNext, PictureComp, HiddenHorizontalScrollbar, InfiniteScroll, TIMELINE_PAGE_ANCHOR }
}

})